import { Paper, PaperProps } from '@mui/material';
import type { ReactElement } from 'react';
import { useRef } from 'react';
import Draggable from 'react-draggable';

function DraggableComponent(props: PaperProps): ReactElement {
  const dragef = useRef(null);
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"], [data-testid="closeIcon"]'}
      nodeRef={dragef}
    >
      <Paper ref={dragef} className="common-diaglog-paper" {...props} />
    </Draggable>
  );
}

export default DraggableComponent;
